<template>
  <div>
    <div class="d-flex mb-2">
      <h4>Подробная статистика по часам</h4>
      <b-spinner v-if="loading" class="mb-2 ml-3"></b-spinner>
    </div>
    <b-table v-bind="statsTableProps">
      <div slot="table-busy" class="text-center">
        <strong>Загрузка статистики...</strong>
      </div>
      <template slot="FOOT_datetime">
        Итого:
      </template>
      <template :slot="'FOOT_' + slot" slot-scope="data" v-for="slot in mainSlots">
        <div :key="slot">
          <b-table v-bind="innerTableProps(workshopFormatter(reduceSummaryStats(data.column)))">
            <template slot="HEAD_stats" slot-scope="data">
              <strong class="d-flex justify-content-between"><span>Кол-во</span><span>Сумма</span></strong>
            </template>
            <template slot="title" slot-scope="data">
              {{data.value}}{{data.item.stats.avg !== undefined ? ': ' + data.item.stats.avg : ''}}
            </template>
            <template slot="stats" slot-scope="data">
              <div class="d-flex justify-content-between"><span>{{data.value.count}}</span><span>{{data.value.sum}}</span></div>
            </template>
            <template slot="percent" slot-scope="data">
              {{data.item.stats.percent ? (data.item.stats.percent).toFixed(2) : ''}}
            </template>
          </b-table>
        </div>
      </template>
      <template slot="FOOT_total" slot-scope="data">
        <div>
          <b-table v-bind="innerTableProps(sumTotalStats())">
            <template slot="HEAD_stats" slot-scope="data">
              <strong class="d-flex justify-content-between"><span>Кол-во</span><span>Сумма</span></strong>
            </template>
            <template slot="title" slot-scope="data">
              {{data.value}}{{data.item.stats.avg !== undefined ? ': ' + data.item.stats.avg : ''}}
            </template>
            <template slot="stats" slot-scope="data">
              <div class="d-flex justify-content-between"><span>{{data.value.count}}</span><span>{{data.value.sum}}</span></div>
            </template>
            <template slot="percent" slot-scope="data">
              {{data.item.stats.percent ? (data.item.stats.percent).toFixed(2) : ''}}
            </template>
          </b-table>
        </div>
      </template>
      <template :slot="slot" slot-scope="data" v-for="slot in mainSlots">
        <div :key="slot">
          <b-table v-bind="innerTableProps(data.value)">
            <template slot="HEAD_stats" slot-scope="data">
              <strong class="d-flex justify-content-between"><span>Кол-во</span><span>Сумма</span></strong>
            </template>
            <template slot="title" slot-scope="data">
              {{data.value}}{{data.item.stats.avg !== undefined ? ': ' + data.item.stats.avg : ''}}
            </template>
            <template slot="stats" slot-scope="data">
              <div class="d-flex justify-content-between"><span>{{data.value.count}}</span><span>{{data.value.sum}}</span></div>
            </template>
            <template slot="percent" slot-scope="data">
              {{data.item.stats.percent ? (data.item.stats.percent).toFixed(2) : ''}}
            </template>
          </b-table>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>

import {orderWorkshopGetters} from '../constants/vuexGetters'
import {workshopFormatter} from '../helpers/tableDetailedStats'

export default {
  name: 'TableDetailedStatsWorkshop',
  props: {
    stats: {
      type: Array
    },
    vuexNamespace: {
      type: String
    }
  },
  data () {
    return {
      mainSlots: [
        'hotWorkshop',
        'pizzaWorkshop',
        'coldWorkshop'
      ],
      paramsSummaryStats: [

      ]
    }
  },
  methods: {
    reduceSummaryStats (columnName) {
      return this.stats.reduce(
        (accum, item) =>
          JSON.parse(item[columnName]) !== null
            ? accum.concat(JSON.parse(item[columnName]))
            : accum, [])
    },
    /**
     * @param workshops Array
     * */
    sumTotalStats () {
      if (!this.loading) {
        let firstTable = this.allFooterStats[0]
        let result = this.allFooterStats.slice(1).reduce((total, item) => {
          item.forEach(itInner => {
            let itemFromTotal = total.find(itTotal => itTotal.title === itInner.title)
            if (itInner.title === 'Среднее') {
              itemFromTotal.stats.count = 0
              itemFromTotal.stats.sum = 0
            } else {
              itemFromTotal.stats.count += itInner.stats.count
              itemFromTotal.stats.sum += itInner.stats.sum
            }
          })
          return total
        }, firstTable)
        let totalCount = result.reduce((accum, item) => {
          return accum + item.stats.count
        }, 0)
        result.map(item => {
          item.stats.percent = item.stats.count / totalCount * 100
          return item
        })
        return result
      }
    },
    innerTableProps (data) {
      return {
        class: ['mb-0', 'hidded-outline', 'table-inner'],
        hover: true,
        small: true,
        items: data,
        striped: false,
        fields: [
          {
            key: 'title',
            label: 'Время'
          },
          {
            key: 'stats'
          },
          {
            key: 'percent',
            label: '%'
          }
        ]
      }
    },
    workshopFormatter: workshopFormatter
  },
  computed: {
    allFooterStats () {
      let res = []
      this.mainSlots.forEach(item => {
        res.push(workshopFormatter(this.reduceSummaryStats(item)))
      })
      // console.log('allFooterStats', res)
      return res
    },
    loading () {
      return this.$store.getters[`${this.vuexNamespace}/${orderWorkshopGetters.LOADING_STATS_WORKSHOPS_OVERALL}`]
    },
    statsTableProps () {
      return {
        striped: true,
        busy: this.loading,
        showEmpty: true,
        bordered: true,
        footClone: this.stats.length !== 0,
        emptyText: 'Заказов за выбранный период не найдено',
        class: 'table-main',
        items: this.stats,
        primaryKey: 'datetime',
        fields: [
          {
            key: 'datetime',
            label: 'Время',
            formatter: time => this.$moment(time).format('HH:mm')
          },
          {
            key: 'hotWorkshop',
            label: 'Горячий цех',
            formatter: item => { return workshopFormatter(JSON.parse(item)) },
            tdClass: 'innerStats'
          },
          {
            key: 'pizzaWorkshop',
            label: 'Пицца цех',
            formatter: item => { return workshopFormatter(JSON.parse(item)) },
            tdClass: 'innerStats'
          },
          {
            key: 'coldWorkshop',
            label: 'Холодный цех',
            formatter: item => { return workshopFormatter(JSON.parse(item)) },
            tdClass: 'innerStats'
          },
          {
            key: 'total',
            label: 'Итого'
          }
        ]
      }
    }
  }
}
</script>

<style>
  /*td.innerStats {*/
  /*  padding: 0*/
  /*}*/
  .hidded-outline {
    border-style: hidden;
  }
  .table-inner tbody tr:nth-of-type(odd):not(:hover) {
    background: rgba(0,0,0,0);
  }
  .table-main > thead > tr >  th, .table-main > tbody > tr > td {
    border-width: 3px;
  }
</style>
<style scoped>
  .table-main {
    border-width: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableDetailedStatsWorkshop.vue